import { useRouter } from 'next/router'
import { useBogo } from '@mc/bogo-utils'
import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { forwardPlan } from 'experiments/prcng-1266_v1_cm_dual_cta'
import { useQuizEvents } from '../../events'

export const SkipButton = () => {
  const { t } = useTranslation('@mc/next')
  const { trackSkipButtonClick } = useQuizEvents()
  const { isBogoOfferEligible } = useBogo()
  const { query } = useRouter()
  const skipHref = isBogoOfferEligible
    ? paths.bogo
    : forwardPlan(paths.checkout, query) // prcng-1266_v1

  return (
    <Button
      kind='link'
      render={<a href={skipHref} />}
      className='mc-opacity--muted'
      onClick={trackSkipButtonClick}
    >
      {t('findMyClasses.common.skip')}
    </Button>
  )
}
